import React from 'react';
import img404 from "../../../Assets/img/404-final.png";
import { Link } from 'react-router-dom';

const PageNotFound = () => {
  return (
    <div>
        <main class="mt-100 mb-200">
        <div class="container">
            <div class="entry-wraper">
                <div class="row">
                    <div class="col-lg-6 col-md-12 d-lg-block d-none text-center"><img class="d-inline" src={img404} alt=""/></div>
                    <div class="col-lg-6 col-md-12 text-center">
                        <h1 class="mb-20 display-1 mt-5">404</h1>
                        <h4 class="mb-30">Sorry, the requested page cannot be located. It may have been moved or removed. Please navigate back to the homepage.</h4>                       
                        <div class="form-group">
                            <Link to="/" class="btn btn btn-dark">Back to Home</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </div>
  )
}

export default PageNotFound